module.exports = __webpack_public_path__ + "static/media/error.02ec39c1.png";